import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  JustifyContent,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import styled from '@emotion/styled'

const PercentOffContainer = styled(Box)`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const DetailContainer = styled(Box)`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  white-space: nowrap;
  min-width: 104px;
`

interface MobileDiscountBoxProps {
  discount: string
  detailText: string
  bgColor: Color
}

export const MobileDiscountBox: React.FC<MobileDiscountBoxProps> = ({
  discount,
  detailText,
  bgColor,
}) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    alignItems={AlignItems.Stretch}
    width={'100%'}
  >
    <PercentOffContainer
      bg={bgColor}
      flexGrow={1}
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
    >
      <Text size={9} color={Color.White} fontWeight={FontWeight.Bold}>
        {discount}%
        <br />
        OFF
      </Text>
    </PercentOffContainer>
    <DetailContainer
      bg={Color.White}
      borderBottomWidth={0.5}
      borderLeftWidth={0.5}
      borderRightWidth={0.5}
      borderColor={Color.ColdGrey_100}
      borderStyle={BorderStyle.Solid}
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      paddingV={1}
    >
      <Text
        size={2}
        color={Color.ColdGrey_800}
        fontWeight={FontWeight.Bold}
        textAlign={TextAlign.Center}
      >
        {detailText}
      </Text>
    </DetailContainer>
  </Box>
)
